import { processName, sortAddress } from "src/utils";
import {
  Avatar,
  Box,
  IconButton,
  makeStyles,
  Typography,
} from "@material-ui/core";
import React, { useState, useEffect, useContext } from "react";
import { BsInstagram } from "react-icons/bs";
import { useHistory } from "react-router-dom";
import SettingsContext from "src/context/SettingsContext";

const useStyles = makeStyles((theme) => ({
  InfluencerCardBox: {
    position: "relative",
    zIndex: "9",
    "& .cryptotextbox": {
      "& h2": {
        color: "#fff",
      },
      "& p": {
        color: "#E6E6E6",
        maxWidth: "800px",
      },
    },
    "& .imagetiktok": {
      width: "100%",
      height: "220px",
      zIndex: "0",
      overflow: "hidden",
      position: "relative",
      borderRadius: "20px",
      backgroundSize: "cover !important",
      backgroundColor: "#ccc !important",
      backgroundRepeat: "no-repeat !important",
    },
    "& .influcenbox": {
      cursor: "pointer",
      zIndex: "1",
      position: "relative",
      transition: "0.5s",
      borderRadius: "20px",
      overflow: "hidden",
      border: "none",
      background: theme.palette.background.card,

      "&:hover": {
        transform: "scale(1.025)",
      },

      "& img": {
        width: "auto",
        maxWidth: "100%",
      },
      "& .textBox": {
        padding: "15px",
      },
    },
  },
}));

export default function InfluencerCard({ value }) {
  const classes = useStyles();
  const themeSeeting = useContext(SettingsContext);
  const history = useHistory();
  const [isValid, setIsValid] = useState(false);
  function isImageUrlValid(url) {
    const img = new Image();
    img.onload = function () {
      setIsValid(true);
    };
    img.onerror = function () {
      setIsValid(false);
    };
    img.src = url;
  }
  useEffect(() => {
    isImageUrlValid(value?.profilePic);
  }, [value?.profilePic]);
  return (
    <Box className={classes.InfluencerCardBox}>
      <Box
        className="influcenbox"
        onClick={() => history.push({ pathname: "/author", search: value._id })}
      >
        <Box
          className="imagetiktok"
          style={{
            backgroundImage: `url(${
              value?.profilePic ? value?.profilePic : ""
            })`,
          }}
        >
          {!isValid && (
            <Avatar
              alt="profile"
              type="profile"
              style={{
                height: "100%",
                width: "100%",
                borderRadius: "0",
              }}
            />
          )}
        </Box>

        <Box className="textBox" align="left">
          <Typography variant="body2" color="primary">
            {value.name ? processName(value.name, 15) :sortAddress(value.walletAddress) ||"..."}
          </Typography>
          <Box className="displayStart">
            <Typography
              variant="body1"
              color="secondary"
              style={{ color: "#706b6b" }}
            >
              Vol Traded:&nbsp;
            </Typography>
            <Typography variant="body1" color="primary">
              {value.totalOrderPrice}
            </Typography>{" "}
            &nbsp;
            <img src="images/qi_logo.png" alt="logo" />
          </Box>
          <Box className="displaySpacebetween" mt={2}>
            <Box className="displayStart">
              <IconButton style={{ padding: "0px 8px 0px 0px" }}>
                <BsInstagram style={{ fontSize: "20px" }} />
              </IconButton>
              <Typography
                variant="body1"
                color="secondary"
                style={{ color: "#706b6b" }}
              >
                {value.instafollowers_count ? value?.instafollowers_count : 0}
              </Typography>
            </Box>

            {/* <Box className="displayStart">
              <IconButton style={{ padding: "0px 8px 0px 0px" }}>
                 <svg
                  width="22px"
                  height="22px"
                  viewBox="0 0 396 398"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M390.4 145.6L249.6 4.8C243.2 -1.6 233.6 -1.6 227.2 4.8L176 56C168 64 171.2 73.6 176 78.4L187.2 89.6L139.2 137.6C115.2 132.8 49.6 121.6 14.4 156.8C8 163.2 8 172.8 14.4 179.2L105.6 270.4L4.8 371.2C-1.6 377.6 -1.6 387.2 4.8 393.6C11.2 400 22.4 398.4 27.2 393.6L128 292.8L219.2 384C228.8 392 238.4 388.8 241.6 384C276.8 348.8 265.6 283.2 260.8 259.2L308.8 211.2L320 222.4C326.4 228.8 336 228.8 342.4 222.4L393.6 171.2C396.8 161.6 396.8 152 390.4 145.6Z"
                    fill={
                      themeSeeting.settings.theme === "DARK" ? "#fff" : "#000"
                    }
                  />
                </svg>
              </IconButton>
              <Typography
                variant="body1"
                color="secondary"
                style={{ color: "#706b6b" }}
              >
                {value.video}
              </Typography>
            </Box> */}
          </Box>
        </Box>
      </Box>
    </Box>
  );
}
